import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { FileExtensionType, getFileExtensionData } from 'owa-files-filter-file-extensions-filter';
import strings from 'owa-strings/owa-photo-hub-strings';
import {
    selectExtensionFilterAction,
    clearExtensionFilterAction,
    expandFileExtensionsFilterMenu,
    collapseFileExtensionsFilterMenu,
} from '../actions/publicActions';

export type IsFileExtensionSelectedFuncType = (value: FileExtensionType) => boolean;
export type IsFileExtensionsExpandedFuncType = () => boolean;

const styles = require('./FileExtensionFilterContextMenu.scss');

export function getFileExtensionContextMenuItems(
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    isExtensionsExpanded: IsFileExtensionsExpandedFuncType,
    allowImagesExtensionType: boolean
): IContextualMenuItem[] {
    const contextMenuItems = [];
    if (allowImagesExtensionType) {
        contextMenuItems.push(
            getExtensionContextMenuItem(FileExtensionType.Images, isExtensionSelected)
        );
    }

    const defaultExtensionOptions = [
        // order matters
        FileExtensionType.Documents,
        FileExtensionType.PowerPoint,
        FileExtensionType.Spreadsheets,
        FileExtensionType.PDFs,
    ].map(e => getExtensionContextMenuItem(e, isExtensionSelected));
    contextMenuItems.push(...defaultExtensionOptions);

    if (isExtensionsExpanded()) {
        const expandedExtensionOptions = [
            FileExtensionType.Text,
            FileExtensionType.Email,
            FileExtensionType.Visio,
            FileExtensionType.Audio,
            FileExtensionType.Xml,
        ].map(e => getExtensionContextMenuItem(e, isExtensionSelected));
        contextMenuItems.push(...expandedExtensionOptions);
    }

    const moreContextmenuItem = getMoreContextMenuItem(isExtensionsExpanded);
    contextMenuItems.push(moreContextmenuItem);
    return contextMenuItems;
}

function getExtensionContextMenuItem(
    extensionFilter: FileExtensionType,
    isExtensionSelected: IsFileExtensionSelectedFuncType
): IContextualMenuItem {
    const extensionGroupData = getFileExtensionData(extensionFilter);
    const isChecked = isExtensionSelected(extensionFilter);

    return {
        key: extensionFilter.toString(),
        name: extensionGroupData.text,
        iconProps: {
            styles: { root: extensionGroupData.icon ? extensionGroupData.icon.small : null },
        },
        canCheck: true,
        checked: isChecked,
        onClick: event => {
            event.preventDefault();
            if (isChecked) {
                clearExtensionFilterAction(extensionFilter);
            } else {
                selectExtensionFilterAction(extensionFilter);
            }
        },
    };
}

function getMoreContextMenuItem(
    isExtensionsExpanded: IsFileExtensionsExpandedFuncType
): IContextualMenuItem {
    const isExpanded = isExtensionsExpanded();
    return {
        key: isExpanded ? strings.showLess : strings.showMore,
        name: isExpanded ? strings.showLess : strings.showMore,
        itemProps: {
            styles: { root: styles.moreRoot, label: styles.moreLabel, icon: styles.noIcon },
        },
        onClick: event => {
            event.preventDefault();

            if (isExpanded) {
                collapseFileExtensionsFilterMenu();
            } else {
                expandFileExtensionsFilterMenu();
            }
        },
    };
}
